<template>
	<el-config-provider :locale="zhCn">
		<router-view />
	</el-config-provider>
</template>

<script setup lang="ts">
	import { ElConfigProvider } from 'element-plus'
	import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
	window.onload = function () {
		document.addEventListener("touchstart", function (event) {
			if (event.touches.length > 1) {
				event.preventDefault();
			}
		});
		document.addEventListener("gesturestart", function (event) {
			event.preventDefault();
		});
	};
</script>

<style lang="scss">
	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
	}
	.el-message {
		z-index: 4001 !important;
	}

	html {
		overflow-y: auto;
	}

	/* 滚动条的宽度 */
	::-webkit-scrollbar {
		width: 8px;
		// height: 0;
	}

	/* 滚动的滑块 */
	::-webkit-scrollbar-thumb {
		border-radius: 10px;
		background: rgba(0, 0, 0, 0.2);
	}

	/* 外层轨道 */
	::-webkit-scrollbar-track {
		border-radius: 0;
		background: rgba(0, 0, 0, 0.1);
	}

	nav {
		padding: 30px;

		a {
			font-weight: bold;
			color: #2c3e50;

			&.router-link-exact-active {
				color: #42b983;
			}
		}
	}

	ul li {
		list-style: disc;
		margin-left: 0.3rem;
	}

	// ul li::marker {
	//   color: black;
	// }

	.el-main {

		background: linear-gradient(180deg, #DAE8FF 0%, rgba(243, 246, 254, 0.98) 100%) !important;
	}

	.master-list {
		background-image: url(../src/images/img/icon_024.png) !important;
		background-size: 100% auto !important;
		background-repeat: no-repeat !important;
		background-position: 0px -72px !important;
		background-color: transparent !important;
	}

	.banner-top {
		background-image: none !important;
	}
</style>